module.exports = __webpack_public_path__ + "img/c18f3e2.jpg";